<template>
    <div class="liga">
        <!-- navbar -->
        <Navbar showBackButton></Navbar>

        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>
        <Loading :loadingState="loadingState">
            <div class="redirect">
                <router-link to="/moje-lige">Ako vas preglednik nije preusmjerio, kliknite ovdje</router-link>
            </div>
            <template v-slot:error>
                <ErrorMessageText :message="message"></ErrorMessageText>
                <a href="#" @click.prevent="goBack" class="button-1 red no-arrow"><span>Povratak u ligu</span></a>
            </template>
        </Loading>

  </div>
</template>
<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import Loading from '../components/common/Loading.vue'
import LoadingState from '../utils/loading/LoadingState'
import ErrorMessageText from '../components/common/error/ErrorMessageText'

export default {
    name: 'pitanje',
    data: function () {
        return {
            loadingState: LoadingState.LOADING,
            message: null
        }
    },
    async mounted () {
        try {
            if (this.ligaId) {
                const data = await this.$db.lige.joinUserLiga({ ligaId: this.ligaId })
                if (data.success) {
                    this.$router.replace({ name: 'mojelige' })
                    this.loadingState = LoadingState.SUCCESS
                } else {
                    this.message = data.message
                    this.loadingState = LoadingState.ERROR
                    return
                }
            }
        } catch (error) {
            this.loadingState = LoadingState.ERROR
        }
    },
    components: {
        Navbar,
        Poveznice,
        Loading,
        ErrorMessageText
    },
    computed: {
        ligaId () {
            return this.$route.params.id
        }
    },
    methods: {
        goBack () {
            this.$router.replace('/home')
        }
    }
}
</script>

<style lang="scss" scoped>
.error-message {
    background: white;
    border-radius: 10px;
    width: 95%;
    margin: 0 auto;
    padding: 10px;
    clear: both;
    display: block;
    margin-bottom: 35px;
    min-height: 100px;
}
.redirect {
    color: white;
    font-size: 22px;
    font-weight: 900;
    margin-top: 20px;
    padding: 0 20px;
}
</style>
